export const submitData = ({ api, method, endpoint, data, onSuccess, onError }) => {
  api[method](endpoint, data)
  .then(response => onSuccess(response))
  .catch(error => onError(error));
};

